import { PropsWithChildren, ReactNode } from "react";
import classNames from "classnames";
import LoyaltyRoundButton from "components/atoms/LoyaltyRoundButton";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";

export type LoyaltyContentProps<T extends string> = {
  children: ReactNode;
  isTransparent?: boolean;
  activeContent?: T;
  setActiveContent?: (cont: T) => void;
  buttons?: Array<{ keyTranslate: string; value: T }>;
  headerContent?: ReactNode;
  className?: string;
  borderBottomHeader?: boolean;
};

const LoyaltyContent = <T extends string>({
  children,
  activeContent,
  setActiveContent,
  isTransparent,
  buttons,
  headerContent = null,
  borderBottomHeader = false,
  className,
}: PropsWithChildren<LoyaltyContentProps<T>>) => {
  const t = useTranslate();

  const classNameHeader = classNames(
    "LoyaltyContent__header",
    !isTransparent && "LoyaltyContent__header_shadow",
    !isTransparent &&
      borderBottomHeader &&
      "LoyaltyContent__header_borderBottom",
  );

  const classNameBackground = classNames(
    "LoyaltyContent__hernya",
    !isTransparent && "LoyaltyContent__hernya_grey",
  );

  const classNameRoot = classNames("LoyaltyContent", className);

  return (
    <div className={classNameRoot}>
      <div className={classNameBackground}>
        <div className="LoyaltyContent__hernyaSquare LoyaltyContent__hernyaSquare_left" />
        <div className={classNameHeader}>
          <div className="LoyaltyContent__square" />
          <div className="LoyaltyContent__bottomPlaceholer" />
          {buttons?.map(({ value, keyTranslate }) => (
            <LoyaltyRoundButton
              key={keyTranslate}
              label={t(keyTranslate)}
              handleClick={() => setActiveContent?.(value)}
              active={activeContent === value}
              className="LoyaltyContent__btn"
            />
          ))}
          {headerContent}
        </div>
        <div className="LoyaltyContent__hernyaSquare LoyaltyContent__hernyaSquare_right" />
      </div>
      <div className="LoyaltyContent__content">{children}</div>
    </div>
  );
};

export default LoyaltyContent;
